import { useContext, useState } from "react";
import LegoAdminPageContext from "../../../pages/legoAdminPageContext";
import SingleTextEditor from "../../common/editors/SingleTextEditor";
import { IconButton } from "../../common/IconButton";
import ModelIdSelector from "../ModelIdSelector";
import useAsyncEffect from "../../common/react-hooks/useAsyncEffect";
import CountryFlag from "../../common/CountryFlag";
import _ from "lodash";
import BadgeColorHash from "../../common/BadgeColorHash";
import LegoEditButton from "../LegoEditButton";
import { LocaleFlag } from "../LocaleFlag";

export default function StableUrlRedirectFinder({ onSelect, initialUrl, initialKey, countries, type, locale }) {
  const { page } = useContext(LegoAdminPageContext);
  const [selectedUrl, setUrl] = useState(initialUrl);
  const [key, setKey] = useState(initialKey);
  const [filter, setFilter] = useState('');

  const [urls, setUrls] = useState(null);

  useAsyncEffect(async () => {
    const query = { type, key, locale, country: { $in: countries } };

    let urls = await page.service('/services/stable-urls/collection').find({ query: query });

    // Filter any urls that are not on every country of countries
    let urlKey = url => url.key + url.url + url.id;
    let urlsByKeyUrlAndId = _.groupBy(urls, urlKey);
    urls = _.filter(urls, url => _.every(countries, country => urlsByKeyUrlAndId[urlKey(url)]?.some(u => u.country === country)));

    if(!urls.length && initialKey !== key) {
      delete query.country;
      // query.country = 'global';
      urls = await page.service('/services/stable-urls/collection').find({ query: query });
    }

    // Don't allow a self redirect
    urls = urls.filter(url => url.url !== initialUrl || url.key !== initialKey);

    setUrls(_.sortBy(urls, u => u.url.startsWith(initialUrl) ? 0 : 1, u => u.url));
  }, [type, key, countries]);

  let urlList = <tr><td colSpan={2} className="text-center">Loading...</td></tr>;

  if (urls) {
    let filteredUrls = filter ? urls.filter(url => url.url.includes(filter)) : urls;


    urlList = filteredUrls.map(url => <tr key={url._id} className={url.active ? (url.url === selectedUrl ? 'bg-light-success' : '') : 'bg-light-secondary'}>
      <td style={{ width: '170px' }}>
        <IconButton icon="arrow_forward" small onClick={() => onSelect({ key: url.key, url: url.url })}>
          Redirect to this url
        </IconButton>
      </td>


      <td className="monospace align-middle">
        <CountryFlag countryCode={url.country} /> &nbsp;
        <span className={url.active ? 'text-info' : 'text-muted'}>{url.url}</span>
      </td>

      <td>
        <LocaleFlag locale={url.locale} />
      </td>

      <td><LegoEditButton legoId={url.id}><BadgeColorHash id={url.id} /></LegoEditButton></td>
    </tr>);
  }

  return <div>
    <ModelIdSelector value={key} onChange={(key) => key && setKey(key)} />


    <table className="table table-sm table-table-striped">
      <thead>
        <tr>
          <th></th>
          <th>
           <div className="d-flex align-items-center" style={{gap: '10px'}}>
            URL
            <SingleTextEditor small placeholder="Filter..." value={filter} onChange={(value) => setFilter(value)} />
           </div>
          </th>
          <th>Locale</th>
          <th>Lego</th>
        </tr>
      </thead>
      {urlList}
    </table>
  </div>;
}
